module.exports = __webpack_public_path__ + "img/vereinsinfos.a2ecdf8d.svg";